module.exports = __webpack_public_path__ + "img/airtke_safe.94223c8f.jpg";